import { SupportQueryService } from '@services/supportQueries.service'
import { fullName } from '@src/utils/settings/tenant-user.util.js'

export default {
  async getSupportQueryTypes({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    const [response, error] = await SupportQueryService.getSupportQueryTypes(commit, payload)
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    commit('layout/IS_LOADING', false, { root: true })
    return [response, error]
  },

  async getsupportQueries({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    const [response, error] = await SupportQueryService.getsupportQueries(commit, payload)
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }

    response.data.records.forEach((record) => {
      fullName(record.guardian)
      fullName(record.teacher)
      if (record.student) fullName(record.student)
    })

    commit('layout/IS_LOADING', false, { root: true })
    return [response, error]
  },

  async getSupportQueryMessages({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    const [response, error] = await SupportQueryService.getSupportQueryMessages(commit, payload)
    response?.data?.records.forEach((record) => {
      if (record?.inserted_by) {
        fullName(record.inserted_by)
        record.full_name = record.inserted_by.full_name
      }
      const supportQuery = record?.support_query
      if (supportQuery) {
        if (supportQuery.student) fullName(supportQuery.student)
        if (Array.isArray(supportQuery.support_query_participants)) {
          supportQuery.support_query_participants.forEach((p) => {
            if (p?.user) fullName(p.user)
          })
        }
      }
    })
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    commit('layout/IS_LOADING', false, { root: true })
    return [response, error]
  },

  async createAndUpdateSupportQueryType({ commit }, payload) {
    const [response, error] = await SupportQueryService.createAndUpdateSupportQueryType(
      payload,
      commit,
    )
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    return [response, error]
  },

  async createAndUpdateSupportQuery({ commit }, payload) {
    const [response, error] = await SupportQueryService.createAndUpdateSupportQuery(payload, commit)
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    return [response, error]
  },

  async addParticipantInConversation({ commit }, payload) {
    const [response, error] = await SupportQueryService.addParticipantInConversation(
      payload,
      commit,
    )
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    return [response, error]
  },
  async addWatcherInConversation({ commit }, payload) {
    const [response, error] = await SupportQueryService.addWatcherInConversation(payload, commit)
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    return [response, error]
  },

  async sendConversationMessages({ commit }, payload) {
    const [response, error] = await SupportQueryService.sendConversationMessages(payload, commit)
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    return [response, error]
  },

  async deleteSupportQuery({ commit }, payload) {
    const [response, error] = await SupportQueryService.deleteSupportQuery(payload, commit)
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    return [response, error]
  },
  async deleteSupportQueryType({ commit }, payload) {
    const [response, error] = await SupportQueryService.deleteSupportQueryType(payload, commit)
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    return [response, error]
  },

  async closeSupportQuery({ commit }, id) {
    const [response, error] = await SupportQueryService.closeSupportQuery(id, commit)
    if (error) commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    return [response, error]
  },
  async reOpenSupportQuery({ commit }, id) {
    const [response, error] = await SupportQueryService.reOpenSupportQuery(id, commit)
    if (error) commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    return [response, error]
  },
}
